// extracted by mini-css-extract-plugin
export default {"isMobile":"Rb8shyz7LO_4SyMIvJBO","title":"IEmNYGZ8Ev6ObvX8UGUi","titleMobile":"c1it9PiRZ6tp_LFVVprf","titleText":"FlKnFVvt2N6uQ_XURYNA"};